import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: "http://localhost:8080", // Local backend base URL

  baseURL: "https://tiara.software/", // production backend base URL

  // baseURL: "http://47.29.121.157:8081/tiarawebsite", // testing backend base URL

  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
